<template>
  <div class="table-lists">
    <el-table :data="list" size="large" style="width: 100%" @row-click="goDetail">
      <el-table-column prop="typeName" label="类别" width="120">
        <template slot-scope="scope">
          <div class="category">
            <span class="recomand-label" v-if="scope.row.recommend">荐</span>
            <span v-if="showMulType && scope.row.category_name" :title="scope.row.category_name" @click.stop="goBigCate(scope.row)">{{scope.row.category_name}}</span>
            <span v-if="showMulType && scope.row.category_name && scope.row.type_name"> · </span>
            <span v-if="scope.row.type_name " :title="scope.row.type_name"  @click.stop="goCate(scope.row)" > {{ scope.row.type_name }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="名称" class-name="name" show-overflow-tooltip />
      <el-table-column prop="author" :label="category == 2 ? '作者' : '责任者/责任方式'" show-overflow-tooltip />
      <el-table-column prop="city" label="区域" show-overflow-tooltip width="150">
        <template slot-scope="scope">
          {{scope.row.city}}{{scope.row.county}}
        </template>
      </el-table-column>
      <!-- <el-table-column prop="produce_time" class-name="time" align="center" :label="category == 3 ? '创作时间' : '出版时间'" width="100">
        <template slot-scope="scope">
          {{scope.row.produce_time}}
        </template>
      </el-table-column> -->
    </el-table>
  </div>
</template>

<script>
import colums from '@/colums/colums.js';
export default {
  name: 'CardTable',
  props: { 
    list:Array,
    showMulType:Boolean,
    newWindow:Boolean,
    source: String,
    category: String|Number
  },
  data(){
    return{
       
    }
  },
  methods:{
    goDetail(item){
      const access = this.source == 'active' ? 0 : this.access || item.no_access || 0
      const hash = this.$utils.hashNum(access)
      if(item.category && item.category_name=='小说'){
        const path = "/book/"+item.id + '/' + hash
        if(this.newWindow){
          let link = this.$router.resolve(path)
          window.open(link.href, '_blank');
          return
        }
        this.$router.push(path)
        return
      }
      const { catename } = this.$route.params
      let url = ''
      if (catename) {
        url = `/literature/${catename}/${item.id}`
      } else {
        const cates = colums.literatureCate || []
        const row = cates.find(v => v.id == item.category) || {}
        if (row.id == 1) {
          url = '/book/' + item.id + '/' + hash
        } else {
          url = row.path + '/' + item.id + '/' + hash
        }
      }
      if(this.newWindow){
        let link = this.$router.resolve(url)
        window.open(link.href, '_blank');
        return
      }
      this.$router.push(url)
    },
    goCate(item){
      this.$router.push({
        path:item.path,
        query:{
          cate:item.category,
          subId: item.type_id
        }
      })
    },

    goBigCate(item){
      this.$router.push({
        path:item.path,
        query:{
          cate:item.category
        }
      })
    }
  },
}
</script>
<style scoped lang="scss">
@import "@/assets/sass/_config";
.table-lists {
  /deep/ .el-table {
    overflow: visible;
    .el-table__header {
      tr {
        background-color: #FFFCFC;
        .el-table__cell {
          background-color: #FFFCFC;
          color: #A6A6A6;
          font-weight: normal;
          padding: 14px 0;
        }
      }
    }
    .el-table__body-wrapper {
      overflow: visible;
    }
    .el-table__body {
      tr {
        @include hoveItem(left);
        &:hover {
          .el-table__cell {
            background-color: #FFF;
          }
          .name {
            color: $main-color;
          }
        }
        .el-table__cell {
          color: #2C2C2C;
          padding: 15px 0;
          font-size: 16px;
          cursor: pointer;
          .category {
            font-size: 14px;
            color: #675046;
            .recomand-label {
              top: 16px;
              left: -25px;
            }
          }
          &.time {
            font-size: 14px;
            color: #A6A6A6;
          }
        }
      }
    }
  }
}
</style>